import React from 'react';
import {
    DEFAULT_PICKUP_FILTERS,
    PICKUP_SEARCH_COLUMNS,
    PICKUP_STATUS_OPTIONS,
    PICKUP_TYPE_OPTIONS,
} from './subparts/pickupQuery';

function OpticalDispensaryToolbar({
    isLoading,
    searchTerm,
    searchColumn,
    showAll,
    status,
    type,
    isConfirmed,
    onClearSearch,
}) {
    const searchColumnLabel = PICKUP_SEARCH_COLUMNS.find((item) => item.value === searchColumn)?.label;
    const statusLabel = PICKUP_STATUS_OPTIONS.find((item) => item.value === status)?.label;
    const typeLabel = PICKUP_TYPE_OPTIONS.find((item) => item.value === type)?.label;

    const hasSearch = Boolean(searchTerm?.trim()) && !showAll;
    const hasStatus = status && status !== DEFAULT_PICKUP_FILTERS.status;
    const hasType = type && type !== DEFAULT_PICKUP_FILTERS.type;
    const hasConfirmed = isConfirmed && isConfirmed !== DEFAULT_PICKUP_FILTERS.isConfirmed;
    const hasReset = hasSearch || showAll || hasStatus || hasType || hasConfirmed;

    if (!hasReset) {
        return null;
    }

    return (
        <div className="optical-dispensary-toolbar">
            <div className="optical-dispensary-toolbar__meta">
                {hasSearch && (
                    <span className="optical-dispensary-chip">
                        <i className="bi bi-funnel" />
                        {searchColumnLabel}: &quot;{searchTerm.trim()}&quot;
                    </span>
                )}
                {showAll && (
                    <span className="optical-dispensary-chip">
                        <i className="bi bi-collection" />
                        All pickup confirmations
                    </span>
                )}
                {hasStatus && (
                    <span className="optical-dispensary-chip">
                        <i className="bi bi-flag" />
                        Status: {statusLabel}
                    </span>
                )}
                {hasType && (
                    <span className="optical-dispensary-chip">
                        <i className="bi bi-eyeglasses" />
                        Type: {typeLabel}
                    </span>
                )}
                {hasConfirmed && (
                    <span className="optical-dispensary-chip">
                        <i className="bi bi-check2-circle" />
                        Confirmed: {isConfirmed === 'true' ? 'Yes' : 'No'}
                    </span>
                )}
            </div>

            {hasReset && (
                <div className="optical-dispensary-toolbar__controls">
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary ecx-modal__close-btn"
                        onClick={onClearSearch}
                        disabled={isLoading}
                    >
                        <i className="bi bi-x-lg me-1" />
                        Reset
                    </button>
                </div>
            )}
        </div>
    );
}

export default OpticalDispensaryToolbar;
